import React, { ReactChild } from 'react';

const IcCash = ({ fill }): ReactChild => {
  const mainFill = fill || '#000';

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0796 6.41883H3.67957V13.9788H18.0796V6.41883ZM2.05957 4.79883V15.5988H19.6996V4.79883H2.05957ZM21.2898 17.1888V5.99883H22.9098V18.8088H4.0998V17.1888H21.2898ZM10.8193 11.9988C11.8134 11.9988 12.6193 11.1929 12.6193 10.1988C12.6193 9.20472 11.8134 8.39883 10.8193 8.39883C9.82522 8.39883 9.01934 9.20472 9.01934 10.1988C9.01934 11.1929 9.82522 11.9988 10.8193 11.9988Z"
        fill={mainFill}
        fillOpacity="0.75"
      />
    </svg>
  );
};

export default IcCash;
